import type { TCsvType } from 'App/data-export/components/_utils/createAndDownloadCsvIfApplicable/createCsv'
import type { TDataExportStoreState } from 'App/data-export/store/dataExportStore'
import { fieldAssetsOptions } from 'App/data-export/store/selectors/fieldAssetsOptions'
import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'

type TFieldAssetLabels = Record<string, string>

export const mapCsvTypeToAvailableFieldAssetLabels: Record<
  TCsvType,
  (
    dataExportStoreState: TDataExportStoreState,
    fieldAssetStoreState: TFieldAssetStoreState,
  ) => TFieldAssetLabels
> = {
  blocks: (dataExportStoreState, fieldAssetStoreState) => {
    const { blocksOptions } = fieldAssetsOptions({
      propertyId: dataExportStoreState.formState.propertyId,
      fieldAssetStoreState,
    })

    return blocksOptions.reduce<TFieldAssetLabels>(
      (acc, cur) => ({
        ...acc,
        [cur.value]: cur.label,
      }),
      {},
    )
  },
  irrigationZones: (dataExportStoreState, fieldAssetStoreState) => {
    const { irrigationZoneEmittersOptions } = fieldAssetsOptions({
      propertyId: dataExportStoreState.formState.propertyId,
      fieldAssetStoreState,
    })

    return irrigationZoneEmittersOptions.reduce<TFieldAssetLabels>(
      (acc, cur) => ({
        ...acc,
        [cur.value]: cur.label,
      }),
      {},
    )
  },
  points: (dataExportStoreState, fieldAssetStoreState) => {
    const { pointsOptions } = fieldAssetsOptions({
      propertyId: dataExportStoreState.formState.propertyId,
      fieldAssetStoreState,
    })

    return pointsOptions.reduce<TFieldAssetLabels>(
      (acc, cur) => ({
        ...acc,
        [cur.value]: cur.label,
      }),
      {},
    )
  },
}
